// extracted by mini-css-extract-plugin
export default {"main":"FuelPrimax_main__jWpcE"};